// vi: filetype=javascript.jsx
import { NessieThemeColors } from "@classdojo/web/nessie/components/theme";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { TranslatedString } from "@classdojo/web/pods/i18n/translate";
import { translate } from "@classdojo/web/utils/translate";
import React from "react";
import SavedToolNewButton from "./SavedToolNewButton";
import logEvent from "src/utils/logEvent";

export type ToolListItem = {
  text: string;
};

export type ToolPayload = {
  title?: string;
  text?: string;
  list?: ToolListItem[];
};

export type Tool = {
  _id?: string;
  dojoId?: string;
  type?: string;
  payload: ToolPayload;

  // FIXME: this is necessary because of some weird logic when rendering DirectionsSenderDisplay
  // the renderResult function receives a tool that has these props due to some
  // redux state inconsistencies.
  list?: ToolListItem[];
  title?: string;
  text?: string;
};

export type AppMetadata = {
  href: string;
  title: TranslatedString;
  backgroundColor: NessieThemeColors;
  icon?: string;
};

type EditableSetupProps = {
  appMetadata: AppMetadata;
  title?: string;
  renderItem: ({
    tool,
    openEditScreen,
    showTool,
  }: {
    tool: Tool;
    openEditScreen: (tool: Tool) => void;
    showTool: (tool: Tool) => void;
  }) => React.ReactElement;
  toolType: string;
  openEditScreen: (tool?: Tool) => void;
  showTool: (tool: Tool) => void;
  tools: Tool[];
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
class EditableSetup extends React.Component<EditableSetupProps> {
  componentDidMount() {
    logEvent({
      eventName: `${this.props.toolType}.setup.open`,
    });
  }

  componentWillUnmount() {
    logEvent({
      eventName: `${this.props.toolType}.setup.close`,
    });
  }

  render() {
    const { openEditScreen, showTool, title } = this.props;
    return (
      <article sx={appStyle}>
        <header>{title ? <p sx={introStyle}>{title}</p> : null}</header>
        <section>
          <ul sx={questionsListStyle}>
            <SavedToolNewButton onClick={this.props.openEditScreen} color={this.props.appMetadata.backgroundColor}>
              {translate({
                str: "dojo.toolkit:other_actions.new",
                fallback: "New",
              })}
            </SavedToolNewButton>
            {this.props.tools &&
              this.props.tools
                .map(({ payload, _id, dojoId }) => ({ ...payload, payload, _id, dojoId }))
                .map((tool) => this.props.renderItem({ tool, openEditScreen, showTool }))}
          </ul>
        </section>
      </article>
    );
  }
}

export default EditableSetup;

const appStyle: ThemeUIStyleObject = {
  textAlign: "center",
  padding: RAW_cssValue("20px"),
};

const introStyle: ThemeUIStyleObject = {
  width: "100%",
  margin: RAW_cssValue("0 auto 25px auto"),
  fontSize: "20px",
  fontWeight: "600",
};

const questionsListStyle: ThemeUIStyleObject = {
  margin: RAW_cssValue("0"),
  padding: RAW_cssValue("0"),
  listStyleType: "none",
};
